<template>
  <div class="content-wrap">
    <div class="card-header">
      <h3 class="title"></h3>
      <div style="display:flex;">
        <div style="marginRight:10px;"
             class="btBox">
          <input @change="upload"
                 type="file"
                 name="photoImg"
                 id="getFile"
                 style="display:none;"
                 class="upload-input" />
          <label for="getFile"
                 class="fileStyle">导入文件</label>

        </div>
        <div style="width:10px"></div>
        <el-button type="primary"
                   @click="handleChapterAdd">添加一级章节</el-button>
      </div>
    </div>
    <div class="table-wrap">
      <el-table ref="table"
                :data="results"
                style="width: 100%;"
                row-key="id"
                :default-expand-all="false"
                :expand-row-keys="expands"
                row-class-name="row-item"
                :tree-props="{children: 'children'}">
        <el-table-column class-name="title-cell"
                         prop="name"
                         label="章节"
                         width="300">
          <template slot-scope="scope">
            <input class="input"
                   v-model="scope.row.name"
                   v-focus="scope.row.id == insertId"
                   placeholder="请输入章节标题"
                   @blur="handleTitleChange(scope.row, $event)" />
          </template>
        </el-table-column>
        <el-table-column prop="item_count"
                         label="总题数"
                         width="100"
                         align="center">
        </el-table-column>
        <el-table-column prop="status"
                         label="在线状态"
                         width="110"
                         align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status"
                    type="success">已发布</el-tag>
            <el-tag v-if="!scope.row.status"
                    type="warning">未发布</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="trial"
                         label="试用状态"
                         width="110"
                         align="center">
          <template v-if="scope.row.level !== 1"
                    slot-scope="scope">
            <el-tag v-if="scope.row.trial"
                    type="success">可试用</el-tag>
            <el-tag v-if="!scope.row.trial"
                    type="warning">不可试用</el-tag>
          </template>
        </el-table-column>
        <el-table-column class-name="edit-cell"
                         label="编辑"
                         align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.level === 1">
              <el-button type="text"
                         @click="handleSubChapterAdd(scope.row)">添加子级</el-button>
              <el-divider direction="vertical"></el-divider>
              <el-button type="text"
                         v-if="scope.row.status == false"
                         @click="handleStatusChange(scope.row, true)">发布</el-button>
              <el-button type="text"
                         v-if="scope.row.status"
                         @click="handleStatusChange(scope.row, false)">下线</el-button>
            </div>
            <div v-if="scope.row.level !== 1">
              <el-button type="text"
                         v-if="scope.row.trial == false"
                         @click="handFreeChange(scope.row, true)">允许试用</el-button>
              <el-button type="text"
                         v-if="scope.row.trial"
                         @click="handFreeChange(scope.row, false)">禁止试用</el-button>
              <el-divider direction="vertical"></el-divider>
              <el-button type="text"
                         @click="handleChapterToEdit(scope.row)">编辑试卷</el-button>
              <el-divider direction="vertical"></el-divider>
              <el-button type="text"
                         v-if="scope.row.status == false"
                         @click="handleStatusChange(scope.row, true)">发布</el-button>
              <el-button type="text"
                         v-if="scope.row.status"
                         @click="handleStatusChange(scope.row, false)">下线</el-button>
              <el-button type="text"
                         @click="handleDowloadPaper(scope.row, false)">下载试卷</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column class-name="action-cell"
                         label="操作"
                         width="140"
                         align="center">
          <template slot-scope="scope">
            <div class="menu-wrap"
                 v-if="scope.row.level === 1">
              <div v-if="handleActionCheck(scope.row, 'up')">
                <el-button type="text"
                           @click="handleSortChange(scope.row, 'up')">上移</el-button>
                <el-divider direction="vertical"></el-divider>
              </div>
              <div v-if="handleActionCheck(scope.row, 'down')">
                <el-button type="text"
                           @click="handleSortChange(scope.row, 'down')">下移</el-button>
                <el-divider direction="vertical"></el-divider>
              </div>
              <div>
                <el-button type="text"
                           @click="handleRemoveChapter(scope.row)">删除</el-button>
              </div>
            </div>
            <div class="menu-wrap"
                 v-if="scope.row.level !== 1">
              <div v-if="handleActionCheck(scope.row, 'up')">
                <el-button type="text"
                           @click="handleSortChange(scope.row, 'up')">上移</el-button>
                <el-divider direction="vertical"></el-divider>
              </div>
              <div v-if="handleActionCheck(scope.row, 'down')">
                <el-button type="text"
                           @click="handleSortChange(scope.row, 'down')">下移</el-button>
                <el-divider direction="vertical"></el-divider>
              </div>
              <div>
                <el-button type="text"
                           @click="handleRemoveChapter(scope.row)">删除</el-button>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {
  examOne,
  examUpdateStatus,
  examChapterList,
  examChapterCreate,
  examChapterUpdate,
  examChaptersUpdate,
  examChapterDestroy,
  byFileImport,
  examPaperOne,
} from '@/api/exam'
import { fileUploadPrivateUrl, uploadHeaders } from '@/config/index'
import { manageUrl } from '@/utils/helper.js'
export default {
  props: {
    exam: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      expands: [],
      insertId: '',
      chapter: {},
      results: [],
      fileList: [],
      fileUploadPrivateUrl: fileUploadPrivateUrl(),
      filename: '',
      isFileInputActive: true,
    }
  },
  created() {
    this.fetchExamChapterList()
  },
  methods: {
    triggerFileInput(event) {
      // 阻止默认行为，防止两次点击
      document.getElementById('photoImg').click()
      event.stopPropagation()
    },
    upload(e) {
      const file = e.target.files[0]

      if (file) {
        /******  此处为上传服务器 start   ******/
        let formData = new FormData()
        formData.append('file', file)
        formData.append('file_exam_total_name', file.name)

        byFileImport(formData).then((res) => {
          console.log('res', res)
          if (res == null) {
            this.$message.success(`导入成功`)
            this.fetchExamChapterList()
          }
        })
      }
    },
    handleAvatarSuccess(file, files) {
      if (files) {
        /******  此处为上传服务器 start   ******/
        let formData = new FormData()
        formData.append('file', files.raw)
        formData.append('file_exam_total_name', files.name)
        byFileImport(formData).then((res) => {
          this.$message.success(`导入成功`)
          this.fetchExamChapterList()
          this.fileList = []
        })
      }
    },
    handlePreview(file) {},
    handleRemove() {},
    beforeRemove() {},
    handleExceed() {},
    // 题库章节列表请求
    fetchExamChapterList() {
      examChapterList({ product_id: this.$route.params.examId }).then((res) => {
        this.results = res.list || []
        if (!this.expands.length) {
          setTimeout(() => {
            this.results.length &&
              this.hendleToggleExpand(this.results[0], true)
          }, 100)
        }
      })
    },
    // 展开行变化记录
    handleExpendChange(row, expand) {
      if (expand) {
        this.expands.push(row.id + '')
      } else {
        this.expands = this.expands.filter((item) => item != row.id)
      }
    },
    // 试用状态变更
    handFreeChange(row, trial) {
      row.trial = trial
      examChapterUpdate({ id: row.id, trial: row.trial ? 1 : 0 })
        .then((res) => {})
        .catch((error) => {
          this.$message.error('试用状态更新异常')
          console.log('error: ', error)
        })
    },
    // 排序位置变化
    handleSortChange(row, sort) {
      let { index, list } = this.computeIndex(row.id)
      let item = list.splice(index, 1)[0]
      if (sort == 'up') {
        list.splice(index - 1, 0, item)
      } else if (sort == 'down') {
        list.splice(index + 1, 0, item)
      }
      const rows = list.map((item, sort) => {
        return { id: item.id, sort: sort }
      })
      examChaptersUpdate(rows)
        .then((res) => {})
        .catch((error) => {
          this.$message.error('章节排序更新异常')
          console.log('error: ', error)
        })
    },
    // 删除章节
    handleRemoveChapter(row) {
      let { index, list } = this.computeIndex(row.id)
      if (row.children && row.children.length) {
        return this.$message.error('请清除子节点后再进行删除操作')
      }
      examChapterDestroy({ id: row.id })
        .then((res) => {
          list.splice(index, 1)[0]
        })
        .catch((error) => {
          this.$message.error('章节删除失败')
          console.log('error: ', error)
        })
    },
    // 数据位置计算
    computeIndex(id) {
      let index = null
      let length = 0
      let list = []
      this.results.some((item, i, arr) => {
        if (item.id == id) {
          index = i
          length = this.results.length
          list = arr
          return true
        }
        if (item.children) {
          item.children.some((subItem, subIndex, subArr) => {
            if (subItem.id == id) {
              index = subIndex
              length = item.children.length
              list = subArr
              return true
            }
          })
        }
      })
      return { index, length, list }
    },
    // 排序边界检查
    handleActionCheck(row, type) {
      let { index, length } = this.computeIndex(row.id)
      if (type == 'up') {
        if (index === 0) {
          return false
        }
        if (index > 0 && length > 1) {
          return true
        }
      }
      if (type == 'down') {
        if (index === length - 1) {
          return false
        }
        return true
      }
      return false
    },
    // 章节标题变化
    handleTitleChange(row) {
      examChapterUpdate({ id: row.id, name: row.name })
        .then((res) => {
          this.insertId = ''
        })
        .catch((error) => {
          this.$message.error('章节标题更新异常')
          console.log('error: ', error)
        })
    },
    // 章节试卷编辑
    handleChapterToEdit(row) {
      console.log('编辑章节试卷', row)
      this.$router.push(
        `/exam/detail/${this.$route.params.examId}/chapter/${row.id}`
      )
    },
    // 添加章
    handleChapterAdd() {
      let newChapter = {
        product_id: this.$route.params.examId,
        name: '',
        level: 1,
        status: 0,
      }
      examChapterCreate(newChapter)
        .then((res) => {
          this.insertId = res.id
          res.children = []
          this.results.push(res)
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    // 添加节
    handleSubChapterAdd(row) {
      this.results.forEach((item) => {
        if (item.id != row.id) {
          this.hendleToggleExpand(item, false)
        }
      })

      let newChapter = {
        product_id: this.$route.params.examId,
        pid: row.id,
        name: '',
        level: row.level + 1,
        status: 0,
      }
      examChapterCreate(newChapter)
        .then((res) => {
          this.insertId = res.id
          let { index } = this.computeIndex(row.id)

          // 稍晚一点儿展开行
          if (row.children.length) {
            this.hendleToggleExpand(row)
          } else {
            setTimeout(() => {
              this.hendleToggleExpand(row)
            }, 20)
          }

          if (this.results[index].id == row.id) {
            this.results[index].children.push(res)
          }
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    handleDowloadPaper(row) {
      this.$emit('detailPaper', row)
    },
    // table row 展开状态变化
    hendleToggleExpand(row, expanded = true) {
      this.$refs.table.toggleRowExpansion(row, expanded)
    },
    handleStatusChange(row, status) {
      examChapterUpdate({ id: row.id, status: status ? 1 : 0 })
        .then((res) => {
          this.fetchExamChapterList()
        })
        .catch((error) => {
          this.$message.error('试用状态更新异常')
          console.log('error: ', error)
        })
    },
  },
  directives: {
    focus: {
      // 指令的定义
      inserted: function (el, { value }) {
        if (value) {
          el.focus()
        }
      },
      update: function (el, { value }) {
        if (value) {
          el.focus()
        }
      },
    },
  },
}
</script>

<style scoped lang="less">
.fileStyle {
  position: relative;
  top: 8px;
  margin-top: 30px;
  margin-right: 5px;
  border-radius: 1px;
  padding: 7px 15px;
  color: #ffff;
  background: #409eff;
}
::v-deep .el-upload-list {
  display: none !important;
}
.btBox {
  position: relative;
}
.custom-button {
  position: absolute;
  display: inline-block;
  padding: 10px 20px;
  background-color: #409eff;
  color: white;
  border-radius: 5px;
  cursor: pointer;
}

.custom-button:hover {
  background-color: #409eff;
}
::v-deep .el-upload-list__item-name {
  display: none;
}
::v-deep .el-upload-list__item-status-label {
  display: none !important;
}
.content-wrap {
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  }

  .table-wrap {
    /deep/ .title-cell {
      width: 50px;

      .cell {
        display: flex;
        align-items: center;
      }
      .input {
        width: 250px;
        height: 32px;
        line-height: 32px;
        background: transparent;
        border: 1px solid transparent;
        border-radius: 4px;
        color: #606266;
        padding: 0 15px;
        outline: 0;

        &:focus {
          background: #fff;
          border-color: #409eff !important;
        }
      }

      &:hover .input {
        background: #fff;
        border-color: #dcdfe6;
      }
    }
    /deep/ .action-cell {
      .el-divider--vertical {
        margin: 0 4px;
      }
    }

    /deep/ .row-item {
      &:hover .menu-wrap {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .menu-wrap {
        display: none;
      }
    }
  }
}
</style>
